import React, { Component } from 'react'
import { Switch, withRouter, Route } from 'react-router-dom'

import { authorization } from '../../Module/Auth/Auth'

import { PrivateRoute } from '../../Config/Routing/auth'
import Chat from '../../Containers/Chat/container/Chat'

class ChatRouter extends Component {
  render() {
    return (
      <Switch>
        <Route path={this.props.match.url}>
          <PrivateRoute
            isRestricted={
              !authorization.isCityManager() || authorization.isSpy()
            }
          >
            <Chat />
          </PrivateRoute>
        </Route>
      </Switch>
    )
  }
}

export default withRouter(ChatRouter)
